export enum TABLES_MEALS {
	VEGETARIAN = 'Vegetarian',
	VEGAN = 'Vegan',
	GLUTEN_FREE = 'GlutenFree',
	KOSHER = 'Kosher',
	DAIRY_FREE = 'DairyFree',
	NUT_ALLERGY = 'NutAllergy',
}

export type TablesMeals =
	| typeof TABLES_MEALS.VEGETARIAN
	| typeof TABLES_MEALS.VEGAN
	| typeof TABLES_MEALS.GLUTEN_FREE
	| typeof TABLES_MEALS.KOSHER
	| typeof TABLES_MEALS.DAIRY_FREE
	| typeof TABLES_MEALS.NUT_ALLERGY;

export enum TABLES_ENTITIES {
	ITEMS = 'items',
	GUESTS = 'guests',
	CONTACTS = 'contacts',
	INVOICES = 'invoices',
}

export enum ATTENTION_TYPE {
	PossibleDuplicates = 'PossibleDuplicates',
	NoSeatingAssignment = 'NoSeatingAssignment',
	AuctionItemWithoutMinimumBid = 'AuctionItemWithoutMinimumBid',
}

export type AttentionType =
	| typeof ATTENTION_TYPE.PossibleDuplicates
	| typeof ATTENTION_TYPE.NoSeatingAssignment
	| typeof ATTENTION_TYPE.AuctionItemWithoutMinimumBid;
